import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import IndexContent1 from "../components/Index_Content";
import Footer from "../components/Footer";
import Canonical from "../components/canonical";

export function Home() {
  return (
    <React.Fragment>
      <Canonical />
      <Navbar linkName="Home" />
      <Hero />
      <IndexContent1 />
      <Footer year={new Date().getFullYear()} />
    </React.Fragment>
  );
}
